import React, { useEffect, useState } from "react";
import { s3baseUrl } from "src/config/config";
import { useSnackbar } from "notistack";
import {
  community_feed_action,
  delete_feed_action,
} from "src/DAL/Community/Community";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import { delete_comment_api } from "src/DAL/Community/Comments";
import CustomPopover from "src/components/CustomPopover";
import CustomConfirmation from "src/components/CustomConfirmation";
import { ReactVideoPlayer } from "src/components";
import UserInfoCard from "src/components/CommunityFeed/UserInfoCard";
import ActionsCount from "src/components/CommunityFeed/ActionsCount";
import HandleAction from "src/components/CommunityFeed/HandleAction";
import { htmlDecode } from "src/utils/convertHtml";
import FeedImagesList from "src/components/CommunityFeed/FeedImagesList";
import ShowAllLikes from "src/components/CommunityFeed/ShowAllLikes";
import AddComment from "./AddComment";
import FeedComments from "src/components/CommunityFeed/FeedComments";
import SingleComment from "src/components/CommunityFeed/SingleComment";
import FeedCommentsDouble from "src/components/CommunityFeed/FeedCommentsDouble";

function PostCard({
  feeds_list,
  getFeedsListingOnDelete,
  handleShowDetails,
  handleSelectedImage,
  handleFeedEdit,
  handleUpdateSpecificFeed,
  handleUpdateShowAll,
  feedsList,
  openDetailModal,
}) {
  // const settings = useContentSetting();
  const { socket, userInfo } = useContentSetting();
  const { enqueueSnackbar } = useSnackbar();
  const [showAddComment, setShowAddComment] = useState(false);
  const [openLikesModal, setOpenLikesModal] = useState(false);
  const [showTab, setShowTab] = useState(0);
  const [isLiked, setIsLiked] = useState(true);
  const [isGratituded, setIsGratituded] = useState(true);
  const [commetMessage, setCommetMessage] = useState({});
  const [topLikedUser, setTopLikedUser] = useState([]);
  const [topGratitudeUser, setTopGratitudeUser] = useState([]);
  const [likeCount, setLikeCount] = useState(0);
  const [gratitudeCount, setGratitudeCount] = useState(0);
  const [commentCount, setCommentCount] = useState(0);
  const [playingVideo, setPlayingVideo] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openDeleteComment, setOpenDeleteComment] = useState(false);
  const [formAction, setFormAction] = useState("ADD");
  const [selectedComment, setSelectedComment] = useState({});
  const [totalCommentCount, setTotalCommentCount] = useState(0);
  const [showAllComments, setShowAllComments] = useState(false);
  const [commentSelected, setCommentSelected] = useState({});
  const handleFeedAction = async (id, action) => {
    if (action === "feedlike") {
      setIsLiked(true);
    } else if (action === "feedunlike") {
      setIsLiked(false);
    } else if (action === "gratitude") {
      setIsGratituded(true);
    }
    const formData = new FormData();
    formData.append("action", action);
    formData.append("feed", id);

    const result = await community_feed_action(formData);
    if (result.code === 200) {
      if (action === "feedlike" || action === "feedunlike") {
        // setTopLikedUser(result.action_response.top_liked_user);
        setLikeCount(result.action_response.like_count);
      } else if (action === "gratitude") {
        setTopGratitudeUser(result.action_response.top_gratitude_user);
        setGratitudeCount(result.action_response.gratitude_count);
      }
      if (action === "feedlike") {
        const socketData = {
          action,
          feed_id: id,
          token: localStorage.getItem("token"),
          creator_id: result.action_response.creator_id,
          action_by: result.action_response.sender,
          action_response: result.action_response,
        };
        socket.emit("feed_room_action_event", socketData);
      }
    } else {
      if (action === "feedlike") {
        setIsLiked(false);
      } else if (action === "feedunlike") {
        setIsLiked(true);
      } else if (action === "gratitude") {
        setIsGratituded(false);
      }
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleAgree = async () => {
    setOpenDelete(false);
    const result = await delete_feed_action(feeds_list._id);
    if (result.code === 200) {
      enqueueSnackbar("Post deleted successfully", { variant: "success" });
      getFeedsListingOnDelete(feeds_list._id);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handlePostDetail = (post_id) => {
    handleShowDetails(feeds_list);
  };

  const handleClickImage = (event, index, path) => {
    handleSelectedImage(feeds_list, index);
  };

  const handleViewAllComments = (value) => {
    handleUpdateShowAll(feeds_list._id, value);
  };

  const handleOpenLikedBox = () => {
    setOpenLikesModal(true);
    setShowTab(1);
  };

  const call_on_comment = () => {};

  const handleOpenGratitudeBox = () => {
    setOpenLikesModal(true);
    setShowTab(2);
  };

  const handleCloseSimpleBox = () => {
    setOpenLikesModal(false);
    setShowTab();
  };

  const handleAgreeDelete = (value) => {
    setOpenDelete(true);
  };

  const handleCommentEdit = (value) => {
    setCommentSelected(value);
    setFormAction("EDIT");
    setShowAddComment(true);
  };

  const handleCommentDelete = (selected_comment) => {
    setOpenDeleteComment(true);
    setSelectedComment(selected_comment);
  };

  //Deleting Category
  const handleDelete = async () => {
    setOpenDeleteComment(false);
    const result = await delete_comment_api(selectedComment._id);
    if (result.code === 200) {
      handleUpdateSpecificFeed(feeds_list._id);
      // const socketData = {
      //   action: "delete_comment",
      //   feed_id: selectedComment.feeds,
      //   comment: selectedComment._id,
      //   token: localStorage.getItem("token"),
      //   action_response: result.action_response,
      //   creator_id: result.action_response.creator_id,
      // };
      // socket.emit("feed_room_action_event", socketData);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleMenu = (row) => {
    let MENU_OPTIONS = [];
    if (feeds_list.is_self) {
      MENU_OPTIONS.push(
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick: handleFeedEdit,
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: handleAgreeDelete,
        }
      );
    }
    return MENU_OPTIONS;
  };

  useEffect(() => {
    setIsLiked(feeds_list.is_liked);
    setIsGratituded(feeds_list.is_gratitude);
    setCommetMessage(feeds_list.comment);
    setTopLikedUser(feeds_list.top_liked_user);
    setLikeCount(feeds_list.like_count);
    setTopGratitudeUser(feeds_list.top_gratitude_user);
    setGratitudeCount(feeds_list.gratitude_count);
    setCommentCount(feeds_list.comment_count);
  }, [feeds_list]);
  useEffect(() => {
    if (showAllComments == false) {
      if (commetMessage?.child_comment?.length) {
        setTotalCommentCount(1 + commetMessage?.child_comment?.length);
      } else {
        setTotalCommentCount(1);
      }
    }
  }, [showAllComments, commetMessage]);
  return (
    <div className="profile-cards p-3 mb-3 main-section">
      <div className="d-flex w-100 justify-content-between">
        <UserInfoCard
          profile_image={s3baseUrl + feeds_list.action_info?.profile_image}
          user_name={htmlDecode(feeds_list.action_info?.name)}
          avatar_char={feeds_list.action_info?.name}
          date={feeds_list?.createdAt}
          activity_type={null}
        />

        <div className="poster-logo text-end">
          <span className="d-flex feed-level">
            {feeds_list.is_self && (
              <CustomPopover menu={handleMenu(feeds_list)} data={feeds_list} />
            )}
          </span>
        </div>
      </div>
      <div className="mt-2 post-description">
        {/* {feeds_list.description.length > LONG_TEXT_LIMIT ? (
          isShowMore ? (
            <>
              <p
                onClick={() => handlePostDetail(feeds_list._id)}
                dangerouslySetInnerHTML={{
                  __html: urlify(
                    get_short_string(feeds_list.description, LONG_TEXT_LIMIT)
                  ),
                }}
              ></p>
              <span
                className="ms-2"
                onClick={() => {
                  setIsShowMore(false);
                }}
              >
                See More
              </span>
            </>
          ) : (
            <>
              <p
                onClick={() => handlePostDetail(feeds_list._id)}
                dangerouslySetInnerHTML={{
                  __html: urlify(feeds_list.description),
                }}
              ></p>
              <span
                className="ms-2"
                onClick={() => {
                  setIsShowMore(true);
                }}
              >
                See Less
              </span>
            </>
          )
        ) : (
          
        )} */}
        <p
          onClick={() => handlePostDetail(feeds_list._id)}
          dangerouslySetInnerHTML={{
            __html: feeds_list.description,
          }}></p>
      </div>
      {feeds_list.feed_type === "image" &&
        feeds_list.feed_images &&
        feeds_list.feed_images.length > 0 && (
          <div className="feed-image">
            <FeedImagesList
              feed_images={feeds_list.feed_images}
              handleClickImage={handleClickImage}
            />
          </div>
        )}

      {feeds_list.feed_type === "video" &&
        feeds_list.video_url &&
        feeds_list.description === "" && (
          <div className="feed-image">
            <ReactVideoPlayer
              url={feeds_list.video_url}
              playingVideo={playingVideo}
            />
          </div>
        )}

      {feeds_list.feed_type === "video" &&
        feeds_list.video_url &&
        feeds_list.description !== "" && (
          <div className="feed-image">
            <ReactVideoPlayer url={feeds_list.video_url} />
          </div>
        )}

      <ActionsCount
        handleOpenLikedBox={handleOpenLikedBox}
        likeCount={likeCount}
        topLikedUser={topLikedUser}
        handleOpenGratitudeBox={handleOpenGratitudeBox}
        gratitudeCount={gratitudeCount}
        topGratitudeUser={topGratitudeUser}
      />
      <hr />
      <HandleAction
        isLiked={isLiked}
        handleFeedAction={handleFeedAction}
        setShowAddComment={setShowAddComment}
        showAddComment={showAddComment}
        isGratituded={isGratituded}
        feed_id={feeds_list._id}
        commentCount={commentCount}
      />

      <hr />
      <div className="profile-comments">
        {commentCount > 0 && (
          <>
            {feeds_list.is_show_all ? (
              <FeedComments
                feed_id={feeds_list._id}
                setTotalCommentCount={setTotalCommentCount}
              />
            ) : (
              // <DoubleComments
              //   comment={commetMessage}
              //   handleCommentEdit={handleCommentEdit}
              //   handleCommentDelete={handleCommentDelete}
              //   handleUpdateSpecificFeed={handleUpdateSpecificFeed}
              // />
              <FeedCommentsDouble
                feed_id={feeds_list._id}
                setTotalCommentCount={setTotalCommentCount}
                handleUpdateSpecificFeed={handleUpdateSpecificFeed}
                handleEditComment={handleCommentEdit}
                handleDeleteComment={handleCommentDelete}
                feedsList={commetMessage}
                commentSelected={commentSelected}
                setCommentSelected={setCommentSelected}
                openDetailModal={openDetailModal}
                handlePostDetail={handlePostDetail}
                setShowAddComment={setShowAddComment}
                showAddComment={showAddComment}
              />
            )}
          </>
        )}
        {commentCount > 2 ? (
          <div className="d-flex justify-content-between">
            <div className="view-comment mt-2 me-3 date-color">
              {!feeds_list.is_show_all ? (
                // <span onClick={() => handleViewAllComments(true)}>
                <span onClick={() => handlePostDetail(feeds_list._id)}>
                  View more comments
                </span>
              ) : (
                <span onClick={() => handleViewAllComments(false)}>
                  View less comments
                </span>
              )}
            </div>
            {/* <div className="view-comment mt-2 me-3 date-color">
              {totalCommentCount} of {commentCount}
            </div> */}
          </div>
        ) : (
          ""
        )}
        {showAddComment && !feeds_list.is_show_all && (
          <AddComment
            post_id={feeds_list._id}
            get_date={call_on_comment}
            formAction={formAction}
            feedsData={feeds_list}
            setFormAction={setFormAction}
            setShowAddComment={setShowAddComment}
            handleUpdateSpecificFeed={handleUpdateSpecificFeed}
            commentSelected={commentSelected}
            setCommentSelected={setCommentSelected}
          />
        )}
      </div>
      {openLikesModal === true && (
        <ShowAllLikes
          openLikesModal={openLikesModal}
          setOpenLikesModal={setOpenLikesModal}
          handleCloseSimpleBox={handleCloseSimpleBox}
          showTab={showTab}
          post_id={feeds_list._id}
          feeds_type="general"
        />
      )}
      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete this post?"}
        handleAgree={handleAgree}
      />
      <CustomConfirmation
        open={openDeleteComment}
        setOpen={setOpenDeleteComment}
        title={"Are you sure you want to delete this comment?"}
        handleAgree={handleDelete}
      />
    </div>
  );
}

export default PostCard;
